export enum CategoryType {
  Query = 1,
  Topic = 2,
  Uncategorized = 3,
  CategoryGroup = 4,
}
